<div class="mainContent">
<div class="pageHeader">Dashboard</div>

<div class="allItems">
  <div class="numberContent">
    <div class="flex-child itemImg">
      <mat-icon>people_alt</mat-icon>
    </div> 
    <div class="flex-child itemCount">
      <p class="countNum">{{userCount}}</p>
      <p class="countContext" i18n>Users</p>    
    </div>
  </div>

  <div class="numberContent">
    <div class="flex-child itemImg">
      <mat-icon>devices</mat-icon>
    </div>
    <div class="flex-child itemCount">
      <p class="countNum">{{deviceCount}}</p>
      <p class="countContext" i18n>Devices</p>
    </div>
  </div>

  <div class="numberContent">
    <div class="flex-child itemImg">
      <mat-icon>dashboard</mat-icon>
    </div>
    <div class="flex-child itemCount">      
        <p class="countNum">{{regionCount}}</p>
        <p class="countContext" i18n>Regions</p>     
    </div>
  </div>
</div>

<div class="user-card-list">
  <mat-card class="usersList">
    <mat-card-header>
      <mat-card-title>
        <div class="headFilter">
          <h2 i18n>Users</h2>
          <div class="customerFilterField">
            <mat-form-field class="my-form-field homeFilterField">
              <mat-label>Filter</mat-label>
              <input matInput (keyup)="userFilter($event)">
            </mat-form-field>
          </div>
          <mat-card-title class="actionButton">
            <button mat-button i18n-matTooltip matTooltip="Display Options"  (click)="setDisplayPermissions()">
              <mat-icon class="displayIcon">group</mat-icon>
            </button>           
          </mat-card-title>
        </div>
      </mat-card-title>
      <mat-card-subtitle>
        <div class="contentContainer">
          <table mat-table [dataSource]="userDataSource" matSort>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> UserName </th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="role">
              <th mat-header-cell  *matHeaderCellDef mat-sort-header  i18n> Role </th>
              <td mat-cell *matCellDef="let element"> {{element.role}} </td>
            </ng-container>

            <ng-container matColumnDef="domain">
              <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Domain </th>
              <td mat-cell *matCellDef="let element"> {{element.domain}} </td>
            </ng-container>

            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> First Name </th>
              <td mat-cell *matCellDef="let element" class="truncate"> {{element.firstName}} </td>
            </ng-container>

            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Last Name </th>
              <td mat-cell *matCellDef="let element" class="truncate"> {{element.lastName}} </td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Email </th>
              <td mat-cell *matCellDef="let element" class="truncate"> {{element.email}} </td>
            </ng-container>

            <ng-container matColumnDef="company">
              <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Company </th>
              <td mat-cell *matCellDef="let element" class="truncate"> {{element.company}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef i18n> Status </th>
              <td mat-cell *matCellDef="let element"> {{element.status}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedUserColumns"></tr>
            
            <tr mat-row *matRowDef="let row; columns: displayedUserColumns;"
            [ngClass]="{hovered: row.hovered}"
            (mouseover)="row.hovered = true" (mouseout)="row.hovered = false" class="selUser" (click)="onSelectedUser(row)"></tr>
          </table>
        </div>
      </mat-card-subtitle>
    </mat-card-header>

  </mat-card>
</div>

<div class="card-list">
    <mat-card class="card-list-item">
      <mat-card-header>
        <mat-card-title>
          <div class="headFilter">
            <h2 i18n>Devices</h2>
            <mat-form-field class="my-form-field homeFilterField">
              <mat-label>Filter</mat-label>
              <input matInput (keyup)="deviceFilter($event)">
            </mat-form-field>
          </div>
        </mat-card-title>
        <mat-card-subtitle>
          <div class="contentContainer">
            <table class="tableContent" mat-table [dataSource]="devDataSource" matSort>          
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>

              <ng-container matColumnDef="platform">
                <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Platform </th>
                <td mat-cell *matCellDef="let element"> {{element.platform}} </td>
              </ng-container>

              <ng-container matColumnDef="registeredon">
                <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Date Registered </th>
                <td mat-cell *matCellDef="let element"> {{element.registeredOn}} </td>
              </ng-container>

              <ng-container matColumnDef="appversion">
                <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> APP Version </th>
                <td mat-cell *matCellDef="let element"> {{element.appVersion}} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedDeviceColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedDeviceColumns;" [routerLink]="['device',row.id]"
              (mouseover)="row.hovered = true" (mouseout)="row.hovered = false" [ngClass]="{hovered: row.hovered}"></tr>
            </table>
          </div>         
        </mat-card-subtitle>
      </mat-card-header>
    </mat-card>

    <mat-card class="card-list-item regionCard">
      <mat-card-header>
        <mat-card-title>
          <div class="headFilter">
            <h2 i18n>Regions</h2>
            <mat-form-field class="my-form-field homeFilterField">
              <mat-label>Filter</mat-label>
              <input matInput (keyup)="regionFilter($event)">
            </mat-form-field>
          </div>
        </mat-card-title>
        <mat-card-subtitle>
          <div class="contentContainer">
            <table class="tableContent" mat-table [dataSource]="regionDataSource" matSort >            
              <ng-container matColumnDef="name">
                <th class="wideColumn" mat-header-cell *matHeaderCellDef mat-sort-header i18n> Name </th>
                <td class="wideColumn" mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>
              <ng-container matColumnDef="area">
                <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> User </th>
                <td mat-cell *matCellDef="let element"> {{element.numberofUsers}} </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Status</th>
                <td mat-cell *matCellDef="let element"> {{element.cacheStatus}} </td>
              </ng-container>
             
              <tr mat-header-row *matHeaderRowDef="displayedRegionColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedRegionColumns;"
              [routerLink]="['region',row.id]"
              [ngClass]="{hovered: row.hovered}"
              (mouseover)="row.hovered = true" (mouseout)="row.hovered = false" ></tr>
            </table>
          </div>         
        </mat-card-subtitle>
      </mat-card-header>
    </mat-card>
</div>
</div>
